import React from 'react';
import { CardDeck, Container } from 'reactstrap';
import InfoCard from '../InfoCard';
import './style.css';

export const cardData = [
  {
    title: 'Addictions',
    subtitle:
      "We support people reducing or recovering from substance use, and those affected by a loved one's use.",
  },
  {
    title: 'Relationship Counseling',
    subtitle:
      'We provide couples and adult family therapy with support for addictions and maternal mental health.',
  },
  {
    title: 'Maternal Mental Health',
    subtitle:
      'We specialize in perinatal, postpartum, and reproductive mental health care.',
  },
];

export const InfoCardGroup = ({ style }) => (
  <Container fluid style={style}>
    <CardDeck className="col-tablet">
      {cardData.map(card => (
        <InfoCard {...card} key={card.title} />
      ))}
    </CardDeck>
  </Container>
);

export default InfoCardGroup;
